import { map } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LogService } from './log.service';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

const API_URL = environment.api_url;

@Injectable({
  providedIn: 'root',
})
export class RestService {
  private http = inject(HttpClient);
  private authS = inject(AuthService);
  private logS = inject(LogService);

  constructor() {
    this.logS.log_construct('service', 'AUTH');
  }

  /** --------------------------------------------------------------------------------------------------------------- */

  get(url: string, auth: boolean = true): Observable<any> {
    // LOG
    this.logS.warn_dev('GET ' + API_URL + url);

    // HEADERS
    let headers = null;
    if (auth) {
      this.checkToken();
      headers = new HttpHeaders({
        Authorization: `Bearer ${this.authS.token}`,
      });
    }

    // REQUEST
    return this.http.get(API_URL + url, { headers }).pipe(
      map(
        response => {
          return this.checkCode(response);
        },
        error => {
          console.error(`GET ERROR: ${url}`, error);
        },
      ),
    );
  }

  post(url: string, body: any, is_file: boolean = false, auth: boolean = true): Observable<any> {
    // LOG
    this.logS.warn_dev('POST ' + API_URL + url);

    // HEADERS
    let headers = null;
    if (auth) {
      this.checkToken();
      headers = new HttpHeaders({
        Authorization: `Bearer ${this.authS.token}`,
      });
    }
    let responseType;
    if (is_file) {
      responseType = 'blob';
    } else {
      responseType = 'json';
    }

    // IP
    body['ip_wan'] = this.authS.ip_wan;
    body['ip_lan'] = JSON.stringify(this.authS.ip_lan);

    // REQUEST
    return this.http.post(API_URL + url, JSON.stringify(body), { headers, responseType }).pipe(
      map(
        response => {
          return this.checkCode(response);
        },
        error => {
          console.error(`POST ERROR: ${url}`, error);
        },
      ),
    );
  }

  /** --------------------------------------------------------------------------------------------------------------- */

  getExternal(url: string, auth: string = null): Observable<any> {
    // LOG
    this.logS.warn_dev('GET EXTERNAL ' + url + ' > ' + auth);

    // HEADERS
    let headers = null;
    if (auth) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${auth}`,
      });
    }

    // REQUEST
    return this.http.get(url, { headers }).pipe(
      map(
        response => {
          if (this.checkCode(response)) {
            return response;
          }
        },
        error => {
          console.error(`GET ERROR: ${url}`, error);
        },
      ),
    );
  }

  postExternal(url: string, body: any, auth: string = null): Observable<any> {
    // LOG
    this.logS.warn_dev('POST EXTERNAL ' + url + ' > ' + auth);

    // HEADERS
    let headers = null;
    if (auth) {
      headers = new HttpHeaders({
        Authorization: `Bearer ${auth}`,
      });
    }

    // REQUEST
    return this.http.post(url, body instanceof FormData ? body : JSON.stringify(body), { headers }).pipe(
      map(
        response => {
          if (this.checkCode(response)) {
            return response;
          }
        },
        error => {
          console.error(`POST ERROR: ${url}`, error);
        },
      ),
    );
  }

  /** --------------------------------------------------------------------------------------------------------------- */

  checkToken() {
    if (!this.authS.token || !this.authS.user) {
      this.authS.logout();
    }
  }

  checkCode(response) {
    switch (response.errors?.code) {
      case 401:
        this.authS.logout();
        return;
      case 403:
        this.authS.logout();
        return;
    }
    return response;
  }
}
